import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../Icon';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Tag = function Tag(_ref) {
  var active = _ref.active,
      activeIcon = _ref.activeIcon,
      disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className,
      ghost = _ref.ghost,
      icon = _ref.icon,
      darker = _ref.darker,
      onClick = _ref.onClick,
      placeholder = _ref.placeholder,
      small = _ref.small;
  var classes = classnames('ptr-Tag', {
    'is-active': active,
    'is-ghost': ghost,
    'is-interactive': !!onClick,
    'is-darker': darker,
    'is-disabled': disabled,
    'is-small': small,
    'is-placeholder': placeholder,
    'is-placeholder-light': placeholder === 'light'
  }, className);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      onClick();
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    tabIndex: !onClick || disabled ? -1 : 0,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    children: [activeIcon ? /*#__PURE__*/_jsx(Icon, {
      icon: "ri-check"
    }) : null, icon ? /*#__PURE__*/_jsx(Icon, {
      icon: icon
    }) : null, children ? /*#__PURE__*/_jsx("div", {
      className: "ptr-Tag-caption",
      children: children
    }) : null]
  });
};

Tag.propTypes = {
  active: PropTypes.bool,
  activeIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  ghost: PropTypes.bool,
  icon: PropTypes.string,
  darker: PropTypes.bool,
  onClick: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  small: PropTypes.bool
};
export default Tag;